<div class="modal-header justify-content-between p-3">
  <h5 class="modal-title fw-semibold" style="font-family: Poppins-Regular;">Change Password</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
</div>
<div class="modal-body px-5">


      <div class="mb-3">
        <div class="input-group mb-0 pb-0 position-relative" style="width: 18em;">
          <input type="text" autocomplete="username" name="username"
            style="position:absolute; left:-9999px; top:auto; width:1px; height:1px; opacity:0; border:0; padding:0; margin:0;"
            tabindex="-1" aria-hidden="true" />

          <input [type]="showNewPassword ? 'text' : 'password'" id="newPassword" [(ngModel)]="newPassword" required
            (input)="onNewPasswordKeyup()" placeholder=" " [attr.autofocus]="isNewPasswordFocused ? true : null"
            (focus)="isNewPasswordFocused = true; $any($event.target)?.removeAttribute('readonly')"
            (blur)="isNewPasswordFocused = false"
            autocomplete="new-password" name="new-password" autocorrect="off" autocapitalize="off" spellcheck="false"
            readonly />
          <label for="newPassword">New Password</label>
        </div>
        <span class="eye_reset" style="cursor:pointer;" (click)="toggleNewPasswordVisibility()">
          <img class="img_class" [src]="showNewPassword ? 'assets/icons/eyeOpen.svg' : 'assets/icons/eyeClose.svg'"
            alt="Show/Hide Password" width="20" height="20">
        </span>
        <span *ngIf="newPassError" class="text-danger mt-0 pt-0 mb-2" style="font-size: small;">
          {{ newPassError }}
        </span>
      </div>

      <div class="mb-3">
        <div class="input-group mb-0 pb-0 mt-3 position-relative" style="width: 18em;">
          <input [type]="showConfirmPassword ? 'text' : 'password'" id="confirmPassword" [(ngModel)]="confirmPassword"
            (input)="onConfirmPasswordKeyup()" required placeholder=" "
            [attr.autofocus]="isConfirmPasswordFocused ? true : null" (focus)="isConfirmPasswordFocused = true"
            (blur)="isConfirmPasswordFocused = false" />
          <label for="confirmPassword">Confirm Password</label>
        </div>
        <span class="eye_reset" style="cursor:pointer;" (click)="toggleConfirmPasswordVisibility()">
          <img class="img_class" [src]="showConfirmPassword ? 'assets/icons/eyeOpen.svg' : 'assets/icons/eyeClose.svg'"
            alt="Show/Hide Password" width="20" height="20">
        </span>
        <span *ngIf="error" class="text-danger mt-0 pt-0" style="font-size: small;">
          {{ error }}
        </span>
      </div>

      <div class="mb-4">
        <button type="submit" class="mainBtn w-100" (click)="updatePassword()">Submit</button>
      </div>
    </div>
